import { GridValueFormatterParams } from '@mui/x-data-grid';

/**
 * The Finnish display formats, for dayjs. Not locale-derived on purpose: these are the shapes the
 * backoffice has settled on, and every view showing a date or a clock reading uses them so the app
 * reads the same throughout.
 */
export const FinnishDateFormat = 'D.M.YYYY';
export const FinnishDayAndMonthFormat = 'D.M.';
export const FinnishTimeFormat = 'HH.mm:ss';
export const FinnishShortTimeFormat = 'HH.mm';

export const cellDataGridDateTime = (params: GridValueFormatterParams): string => {
  return dateTimeLocal(params.value as string);
};

export const dateTimeLocal = (isoDate: string | undefined | null): string => {
  if (!isoDate) {
    return 'Invalid date';
  }
  const date = new Date(Date.parse(isoDate));
  return `${date.toLocaleDateString('fi-FI')} ${date.toLocaleTimeString('fi-FI', {
    hour: 'numeric',
    minute: '2-digit',
  })}`;
};

// The users API serves some timestamps as UTC without a timezone designator, which Date.parse would
// otherwise read as local time. Marks such a value as UTC before formatting it in the local zone.
// Returns null when the value is missing or cannot be parsed, so callers can render their own fallback.
export const utcDateTimeLocal = (utcDate: string | undefined | null): string | null => {
  if (!utcDate) {
    return null;
  }
  const hasTimeZone = /(Z|[+-]\d{2}:?\d{2})$/i.test(utcDate);
  const normalized = hasTimeZone ? utcDate : `${utcDate}Z`;

  if (Number.isNaN(Date.parse(normalized))) {
    return null;
  }

  return dateTimeLocal(normalized);
};
